import {
  Box,
  Flex,
  ListItem,
  Primary12SemiBold,
  UnorderedList
} from '@sequencehq/core-components'
import { getValidationFieldLabels } from './customerValidationLabels'
import { SelectableCustomer } from './integrationCustomer.types'

export const CustomerValidationTooltip = (props: {
  invalidReason?: string
  validationErrors?: SelectableCustomer['validationErrors']
  integrationName?: string | null
  'data-testid': string
}) => {
  const dataTestId = props['data-testid']
  const missingLabels = getValidationFieldLabels(
    props.validationErrors,
    'MISSING'
  )
  const invalidLabels = getValidationFieldLabels(
    props.validationErrors,
    'INVALID'
  )
  const hasFieldErrors = missingLabels.length + invalidLabels.length > 0

  return (
    <Flex flexDirection="column" gap="4px" data-testid={dataTestId}>
      {hasFieldErrors ? (
        <>
          <ValidationFieldGroup
            heading="Missing:"
            labels={missingLabels}
            data-testid={`${dataTestId}.missing`}
          />
          <ValidationFieldGroup
            heading="Invalid:"
            labels={invalidLabels}
            data-testid={`${dataTestId}.invalid`}
          />
        </>
      ) : (
        <Box data-testid={`${dataTestId}.reason`}>{props.invalidReason}</Box>
      )}
      {props.integrationName && (
        <Box data-testid={`${dataTestId}.action`}>
          Update in {props.integrationName} first to import.
        </Box>
      )}
    </Flex>
  )
}

const ValidationFieldGroup = (props: {
  heading: string
  labels: string[]
  'data-testid': string
}) => {
  if (!props.labels.length) {
    return null
  }

  return (
    <Box data-testid={props['data-testid']}>
      <Box {...Primary12SemiBold}>{props.heading}</Box>
      <UnorderedList>
        {props.labels.map(label => (
          <ListItem key={label}>{label}</ListItem>
        ))}
      </UnorderedList>
    </Box>
  )
}
